import React, { useEffect, useState } from "react";
import FeaturedModule from "../components/blogs/FeatuedModule";
// import BlogListSection from "../components/blogs/BlogListSection";
import blog1 from "../data/blogs/blog1.json";
import LoadingSpinner from "../components/generic/LoadingSpinner";
import Seo from "../components/generic/Seo";

const objSeo = {
  title: "Springevening Private Limited",
  description:
    "Read insights, technical articles, startup stories, and engineering blogs from Springevening Private Limited.",
  keywords:
    "software blogs, startup blogs, ERP blogs, technology articles, Springevening",
  pathSlug: "/blogs",
};

const Blogs = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setPosts([blog1]);
    setLoading(false);
  }, []);

  return (
    <>
      <Seo data={objSeo} />
      {loading && <LoadingSpinner height="60vh" />}

      {!loading && posts.length === 0 && (
        <div
          style={{
            minHeight: "60vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <p>No blogs published yet. Please check back soon.</p>
        </div>
      )}

      {/* ✅ Data state */}
      {!loading && posts.length > 0 && (
        <>
          <FeaturedModule posts={posts.slice(0, 4)} />
          {/* <BlogListSection posts={posts.slice(4)} /> */}
        </>
      )}
    </>
  );
};

export default Blogs;
